import { Slot, usePathname } from "@-/com.npmjs.expo-router";
import {
  useAppDatabasesRozeniteSqlite,
  useNavRozeniteControls,
} from "@-/dev.improve.haniverse.components.rozenite";
import { NavLayout } from "@-/dev.improve.haniverse.routes.nav";

export const unstable_settings = {
  anchor: "(app)",
};

/**
 * Public website pages (`@-/dev.improve.haniverse.components.website`) that live under `(nav)` for
 * their native screens. On web they render without the app shell and its providers, so they never
 * depend on auth or initialize the app databases.
 */
const PUBLIC_WEBSITE_PATHNAMES: ReadonlySet<string> = new Set([
  "/deleteme",
  "/privacy",
  "/support",
  "/terms",
]);

function useNoop() {}

export default function WebNavLayoutRoute() {
  (__DEV__ ? useAppDatabasesRozeniteSqlite : useNoop)();

  const pathname = usePathname();
  if (PUBLIC_WEBSITE_PATHNAMES.has(pathname)) {
    return <Slot />;
  }

  return <NavLayout base="(nav)" useDevtools={__DEV__ ? useNavRozeniteControls : undefined} />;
}
